/*
    Filter and Sorter HTML structure
    <div class="collection-nav-block">
        <div class="nav-title">[title]</div>
        <div class="nav-content">
            <div class="nav-list-container">
                [drop down content]
            </div>
        </div>
    </div>
*/

import $, { contains } from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';

export default Backbone.View.extend({
    
    initialize: function (opts) {
        var self = this;
        self.$collection = self.$el;
        self.$sorter = self.$collection.find('.collection-nav-block.sorting');
        self.$filter = self.$collection.find('.collection-nav-block.filters');
        self.$category = self.$collection.find('.collection-nav-block.category');
        self.$mode = self.$collection.find('.collection-nav-block.mode');
        self.$body = $('body');
        self.$header = $('header.site-header');
        self.$footer = $('footer.site-footer');
        self.layout = self.$collection.data('layout');

        self.$filterMenuToggle = self.$collection.find('.filter-menu-toggle');
        self.$filterMenuToggleText = self.$collection.find('.filter-menu-toggle .text');
        self.$mobileFilterMenu = self.$collection.find('.mobile-menu');
        self.$desktopFilterMenu = self.$collection.find('.desktop-menu');
        self.$mobileFilterMenuTriggerClose = self.$collection.find('.mobile-menu-trigger-close');

        self.handleFilterMenuToggle();
        self.handleMobileFilterMenuClose();
        
        self.prepareParams();
        self.initSorting();
        self.initFiltering();

        self.navDropdown();
    },

    events: {
        'click .collection-nav-block .apply-filters' : function(e){                
            e.preventDefault();
            
            const formIdToSubmit = $(e.currentTarget).data('submit');
            const form = $(`#${formIdToSubmit}`);
            
            // Collect form data
            const formData = form.serializeArray();
            const params = new URLSearchParams();

            formData.forEach(item => {
                params.append(item.name, item.value);
            });

            // Update the URL with the new filters
            const url = new URL(window.location);
            url.search = params.toString();
            window.history.pushState({}, '', url);

            // Refresh the page
            location.reload();
        },
        'click .collection-nav-block .clear-all' : function(e){
            e.preventDefault();

            // Clear all filters by updating the URL
            const url = new URL(window.location);
            url.search = ''; // Clear all query parameters
            window.history.pushState({}, '', url);

            // Refresh the page
            location.reload();
        }
    },

    handleFilterMenuToggle: function() {
        // Desktop menu initially opened
        // Mobile menu initially closed
        
        var self = this;

        self.$filterMenuToggle.on('click', function() {
            if(self.isMobile()) {                
                // Here we have only opening functionality, closing functionality is handled by handleMobileFilterMenuClose
                self.$header.removeClass('scroll-up');
                self.$header.addClass('scroll-down');
                self.$body.addClass('overflow-hidden');
                self.$mobileFilterMenu.addClass('open');
            } else {
                if(self.$collection.hasClass('desktop-filter-menu-opened')) {
                    self.$collection.removeClass('desktop-filter-menu-opened');
                    self.$desktopFilterMenu.addClass('hide');
                    self.$filterMenuToggleText.text('Filters');
                } else {
                    self.$collection.addClass('desktop-filter-menu-opened');
                    self.$desktopFilterMenu.removeClass('hide');
                    self.$filterMenuToggleText.text('Hide Filters');
                }
            }
        });

        // If we are on desktop screen, change the filter menu text to 'Hide Filters'
        if(!self.isMobile()) {
            self.$filterMenuToggleText.text('Hide Filters');
        }
    },

    handleMobileFilterMenuClose: function() {
        var self = this;

        self.$mobileFilterMenuTriggerClose.on('click', function() {
            self.$mobileFilterMenu.removeClass('open');
            self.$body.removeClass('overflow-hidden');
        });

    },
    
    prepareParams: function(){
        var self = this;
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                // console.log(aKeyValue);
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
        
        // Clean the pagination
        delete Shopify.queryParams.page;
        delete Shopify.queryParams.showAll;
        
        if (!$.isEmptyObject(Shopify.queryParams)) {
            $('.collection-nav-block.clear-all').removeClass('hide');
            $('.clear-all.clear-all-sort').removeClass('hide');
        }
    },

    navDropdown: function(){
        /*
            The goal here is to use one dropdown handle for both PLP (one-column, two columns) layouts on both large and smaller screen.
            Handling total 4 situations.
        */
        var self = this;
        var navDropdownCtl = function(e){
            e.preventDefault();
            e.stopPropagation();
            var $curr = $(e.currentTarget).parent();
            if (self.layout == 'one-column' && !self.isMobile()) {
                var $currentOpened = self.$collection.find('.nav-dropdown.opened').not($curr);
            } else if (self.isMobile()) {
                var $currentOpened = self.$collection.find('.collection-nav .opened').not($curr);
            } else {
                var $currentOpened = $curr.siblings('.opened');
            }
            // $currentOpened.removeClass('opened');
            $curr.toggleClass('opened');
        }
        var events = {
            'click .nav-title' : navDropdownCtl,
            'click .filter-title' : navDropdownCtl,
        };
        
        // Click outside to close
        // $(window).on('click', function (e) {
        //     self.$body.removeClass('collection-nav-opened');
        //     self.$collection.find('.collection-nav-block.opened').removeClass('opened');
        // });
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initSorting: function(){
        var self = this;
        var events = {
            'click .collection-nav .sorting .filter' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget),
                    sortVal = $curr.data('link');
                
                if (sortVal != '') {
                    $curr.addClass('active').siblings('.filter').removeClass('active');
                    Shopify.queryParams.sort_by = sortVal;
                } else {
                    delete Shopify.queryParams.sort_by;
                }
                
                // Update the URL with the new sorting parameter
                const url = new URL(window.location);
                url.search = $.param(Shopify.queryParams);
                window.history.pushState({}, '', url);

                // Refresh the page
                location.reload();
            }
        }
        
        // Active Status
        if (Shopify.queryParams.sort_by) {            
            console.log('Active sorting: ' + Shopify.queryParams.sort_by);
            
            const activeListItem = $('.collection-nav .sorting .filter[data-link="' + Shopify.queryParams.sort_by + '"]')

            if (activeListItem.length) {
                const activeListItemText = activeListItem.first().text();
                activeListItem.addClass('hide').siblings('.filter').removeClass('hide');
    
                const summaryElementText = $('.collection-nav .sorting summary .active-text');
                summaryElementText.text(activeListItemText);
            }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initFiltering: function(){
        var self = this;
        var $filterSelects = self.$filter.find('select');
        var events = {
            'click .collection-nav-block .filters .filter-swatch' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget),
                    $filterParent = $curr.parents('.filter-swatches'),
                    $fitlerSelect = $filterParent.siblings('select'),
                    filterVal = $curr.data('link');
                    
                if ($curr.hasClass('disabled')) {
                    return false;
                }
                
                if (filterVal !== '') {
                    $curr.addClass('active').siblings('.filter-swatch').removeClass('active');
                    $fitlerSelect.val(filterVal).change();
                } else {
                    // Navigate back to parent collection if no specific filter is selected
                    var newURL = self.parentCollectionLink || `/collections/${Shopify.collectionHandle}`;
                    var search = $.param(Shopify.queryParams);
                    if (search.length) {
                        newURL += '?' + search;
                    }
                    location.href = newURL;
                }
            },
            'change .collection-nav-block .filters select' : function(e){
                delete Shopify.queryParams.page;
                var newTags = [];
                _.each($filterSelects, function(select){
                    if ($(select).val()) {
                        newTags.push($(select).val());
                    }
                });
                if (Shopify.collectionHandle) {
                    // PLP
                    var newURL = '/collections/' + Shopify.collectionHandle;
                    var search = $.param(Shopify.queryParams);
                    
                    if (newTags.length) {
                        newURL += '/' + newTags.join('+');
                    }
                    if (search.length) {
                        newURL += '?' + search;
                    }
                    
                    location.href = newURL;
                } else {
                    // Search
                    if (newTags.length) {
                        Shopify.queryParams.constraint = newTags.join('+');
                    } else {
                        delete Shopify.queryParams.constraint;
                    }

                    location.search = $.param(Shopify.queryParams);
                }
            },
            // Automatically submit filters on checkbox click
            'click .filter-checkbox': function(e) {
                e.preventDefault();
                const form = $(e.currentTarget).closest('form');
                const formData = form.serializeArray();
                const params = new URLSearchParams();
    
                // Append all selected filters to params
                formData.forEach(item => {
                    params.append(item.name, item.value);
                });

                // Update the URL with selected filters
                const url = new URL(window.location);
                url.search = params.toString();
                window.history.pushState({}, '', url);

                // Reload the page to apply filters
                location.reload();
            }
        };
        
        // Build the fake 'Style' filter using main navigation, will be disabled for Phase 2
        self.navLinkFilters();
        
        // Update applied filter count
        var appliedFilterCount = self.$filter.find('.active').length;
        if (appliedFilterCount > 0) {
            var $navTitle = self.$filter.find('.nav-title');
            $navTitle.text($navTitle.data('title') + ' (' + appliedFilterCount + ')');
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    navLinkFilters: function(){
        var self = this;
        var $rawNav = ORW.Global?.$rawNav ? ORW.Global.$rawNav.clone() : $('header.site-header nav').clone();
        var currentUrl = self.$collection.data('url');
        self.parentCollectionLink = false;
        
        // Build fake collection filter
        var $activeLink = $rawNav.find('a[href="' + currentUrl + '"]');
        if ($activeLink.length) {
            var $children = $activeLink.siblings('.children');
            if ($children.length) {
                // console.log('on parent level!');
                self.$filter.find('.filter.collection .filter-swatches').html($children.html());
                self.$filter.find('.filter.collection').show();
            } else if ($activeLink.parent().hasClass('level-3')) {
                // console.log('on sub level!');
                $children = $activeLink.parent().parent('.children');
                if ($children.length) {
                    self.parentCollectionLink = $children.siblings('.nav-link').attr('href');
                    $children.find('a[href="' + currentUrl + '"]').addClass('active');
                    self.$filter.find('.filter.collection .filter-swatches').html($children.html());
                    self.$filter.find('.filter.collection').show();
                    self.$filter.find('.clear-all').removeClass('hide hidden');
                }
            }
        }
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});